const nerveData = [
    //--------Ulnar Nerve--------//
    {
        title: 'Ulnar Nerve 1',
        muscles: ['Flexor Carpi Ulnaris (C7, C8, T1)', 'Flexor Digitorum Profundus III & IV (C7, C8, T1)', 'Dorsal Interossei (C8, T1)', 'Palmar Interossei (C8, T1)', 'Lumbricals III & IV (C8, T1)', 'Adductor Pollicis (C8, T1)', '1/2 Flexor Pollicis Brevis (Deep Head) (C8, T1)', 'Flexor Digiti Minimi (C8, T1)', 'Abductor Digiti Minimi (C8, T1)', 'Opponens Digiti Minimi (C8, T1)', 'Palmaris Brevis (C8, T1)'],
        nerves: ['Dorsal Cutaneous Branch (C8, T1)', 'Palmar Cutaneous Branch (C8, T1)',  'Digital Branches (C8, T1)', 'Deep Motor Branch (C8, T1)', 'Hypothenar Branch (C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Ulnar Nerve 2',
        muscles: ['Flexor Digitorum Profundus III & IV (C7, C8, T1)', 'Dorsal Interossei (C8, T1)', 'Palmar Interossei (C8, T1)', 'Lumbricals III & IV (C8, T1)', 'Adductor Pollicis (C8, T1)', '1/2 Flexor Pollicis Brevis (Deep Head) (C8, T1)', 'Flexor Digiti Minimi (C8, T1)', 'Abductor Digiti Minimi (C8, T1)', 'Opponens Digiti Minimi (C8, T1)', 'Palmaris Brevis (C8, T1)'],
        nerves: ['Dorsal Cutaneous Branch (C8, T1)', 'Palmar Cutaneous Branch (C8, T1)', 'Digital Branches (C8, T1)', 'Deep Motor Branch (C8, T1)', 'Hypothenar Branch (C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Ulnar Nerve 3',
        muscles: ['Dorsal Interossei (C8, T1)', 'Palmar Interossei (C8, T1)', 'Lumbricals III & IV (C8, T1)', 'Adductor Pollicis (C8, T1)', '1/2 Flexor Pollicis Brevis (Deep Head) (C8, T1)', 'Flexor Digiti Minimi (C8, T1)', 'Abductor Digiti Minimi (C8, T1)', 'Opponens Digiti Minimi (C8, T1)', 'Palmaris Brevis (C8, T1)'],
        nerves: ['Dorsal Cutaneous Branch (C8, T1)', 'Palmar Cutaneous Branch (C8, T1)', 'Digital Branches (C8, T1)', 'Deep Motor Branch (C8, T1)', 'Hypothenar Branch (C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Ulnar Nerve 4',
        muscles: ['Dorsal Interossei (C8, T1)', 'Palmar Interossei (C8, T1)', 'Lumbricals III & IV (C8, T1)', 'Adductor Pollicis (C8, T1)', '1/2 Flexor Pollicis Brevis (Deep Head) (C8, T1)', 'Flexor Digiti Minimi (C8, T1)', 'Abductor Digiti Minimi (C8, T1)', 'Opponens Digiti Minimi (C8, T1)', 'Palmaris Brevis (C8, T1)'],
        nerves: ['Palmar Cutaneous Branch (C8, T1)', 'Digital Branches (C8, T1)', 'Deep Motor Branch (C8, T1)', 'Hypothenar Branch (C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Ulnar Nerve 5',
        muscles: ['Dorsal Interossei (C8, T1)', 'Palmar Interossei (C8, T1)', 'Lumbricals III & IV (C8, T1)', 'Adductor Pollicis (C8, T1)', '1/2 Flexor Pollicis Brevis (Deep Head) (C8, T1)', 'Flexor Digiti Minimi (C8, T1)', 'Abductor Digiti Minimi (C8, T1)', 'Opponens Digiti Minimi (C8, T1)', 'Palmaris Brevis (C8, T1)'],
        nerves: ['Digital Branches (C8, T1)', 'Deep Motor Branch (C8, T1)', 'Hypothenar Branch (C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Dorsal Cutaneous Branch (C8, T1)',
        muscles: [],
        nerves: [],
        sensory: [],
        cutaneous: ['Medial Portion of Dorsum of the Hand']
    },
    {
        title: 'Palmar Cutaneous Branch (C8, T1)',
        muscles: [],
        nerves: [],
        sensory: [],
        cutaneous: ['Medial Palm']
    },
    {
        title: 'Hypothenar Branch 1',
        muscles: ['Flexor Digiti Minimi (C8, T1)', 'Abductor Digiti Minimi (C8, T1)', 'Opponens Digiti Minimi (C8, T1)', 'Palmaris Brevis (C8, T1)'], 
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Hypothenar Branch 2',
        muscles: ['Opponens Digiti Minimi (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Hypothenar Branch 3',
        muscles: ['Flexor Digiti Minimi (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Hypothenar Branch 4',
        muscles: ['Abductor Digiti Minimi (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Hypothenar Branch 5',
        muscles: ['Palmaris Brevis (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Digital Branches 1',
        muscles: [],
        nerves: [],
        sensory: [],
        cutaneous: ['Palmar Aspect of Medial 1/2 of Fourth Digit', 'Palmar Aspect of Fifth Digit']
    },
    {
        title: 'Deep Motor Branch 1',
        muscles: ['Dorsal Interossei (C8, T1)', 'Palmar Interossei (C8, T1)', 'Lumbricals III & IV (C8, T1)', 'Adductor Pollicis (C8, T1)', '1/2 Flexor Pollicis Brevis (Deep Head) (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Deep Motor Branch 3',
        muscles: ['Dorsal Interossei (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Deep Motor Branch 4',
        muscles: ['Palmar Interossei (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Deep Motor Branch 5',
        muscles: ['Lumbricals III & IV (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Deep Motor Branch 6',
        muscles: ['Adductor Pollicis (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Deep Motor Branch 7',
        muscles: ['1/2 Flexor Pollicis Brevis (Deep Head) (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },

     //--------Median Nerve--------//
    {
        title: 'Median Nerve 1',
        muscles: ['Pronator Teres (C6, C7)', 'Flexor Carpi Radialis (C6, C7)', 'Palmaris Longus (C7, C8)', 'Flexor Digitorum Superficialis (C7, C8, T1)', 'Flexor Digitorum Profundus I & II (C7, C8)', 'Flexor Pollicis Longus (C7, C8)', 'Pronator Quadratus (C7, C8)', 'Opponens Pollicis (C8, T1)', 'Abductor Pollicis Brevis (C8, T1)', '1/2 Flexor Pollicis Brevis (Superficial Head) (C8, T1)', 'Lumbricals I & II (C8, T1)'],
        nerves: [ 'Anterior Interosseous Nerve (C7, C8)', 'Thenar Cutaneous Branch (C6, C7)', 'Recurrent Motor Branch (C8, T1)', 'Digital Branches (C6, C7, C8)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Median Nerve 2',
        muscles: ['Flexor Carpi Radialis (C6, C7)', 'Palmaris Longus (C7, C8)', 'Flexor Digitorum Superficialis (C7, C8, T1)', 'Flexor Digitorum Profundus I & II (C7, C8)', 'Flexor Pollicis Longus (C7, C8)', 'Pronator Quadratus (C7, C8)', 'Opponens Pollicis (C8, T1)', 'Abductor Pollicis Brevis (C8, T1)', '1/2 Flexor Pollicis Brevis (Superficial Head) (C8, T1)', 'Lumbricals I & II (C8, T1)'],
        nerves: [ 'Anterior Interosseous Nerve (C7, C8)', 'Thenar Cutaneous Branch (C6, C7)', 'Recurrent Motor Branch (C8, T1)', 'Digital Branches (C6, C7, C8)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Median Nerve 3',
        muscles: ['Palmaris Longus (C7, C8)', 'Flexor Digitorum Superficialis (C7, C8, T1)', 'Flexor Digitorum Profundus I & II (C7, C8)', 'Flexor Pollicis Longus (C7, C8)', 'Pronator Quadratus (C7, C8)', 'Opponens Pollicis (C8, T1)', 'Abductor Pollicis Brevis (C8, T1)', '1/2 Flexor Pollicis Brevis (Superficial Head) (C8, T1)', 'Lumbricals I & II (C8, T1)'],
        nerves: [ 'Anterior Interosseous Nerve (C7, C8)', 'Thenar Cutaneous Branch (C6, C7)', 'Recurrent Motor Branch (C8, T1)', 'Digital Branches (C6, C7, C8)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Median Nerve 4',
        muscles: ['Flexor Digitorum Superficialis (C7, C8, T1)', 'Flexor Digitorum Profundus I & II (C7, C8)', 'Flexor Pollicis Longus (C7, C8)', 'Pronator Quadratus (C7, C8)', 'Opponens Pollicis (C8, T1)', 'Abductor Pollicis Brevis (C8, T1)', '1/2 Flexor Pollicis Brevis (Superficial Head) (C8, T1)', 'Lumbricals I & II (C8, T1)'],
        nerves: [ 'Anterior Interosseous Nerve (C7, C8)', 'Thenar Cutaneous Branch (C6, C7)', 'Recurrent Motor Branch (C8, T1)', 'Digital Branches (C6, C7, C8)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Median Nerve 5',
        muscles: ['Flexor Digitorum Profundus I & II (C7, C8)', 'Flexor Pollicis Longus (C7, C8)', 'Pronator Quadratus (C7, C8)', 'Opponens Pollicis (C8, T1)', 'Abductor Pollicis Brevis (C8, T1)', '1/2 Flexor Pollicis Brevis (Superficial Head) (C8, T1)', 'Lumbricals I & II (C8, T1)'],
        nerves: [ 'Anterior Interosseous Nerve (C7, C8)', 'Thenar Cutaneous Branch (C6, C7)', 'Recurrent Motor Branch (C8, T1)', 'Digital Branches (C6, C7, C8)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Anterior Interosseous Nerve',
        muscles: ['Flexor Digitorum Profundus I & II (C7, C8)', 'Flexor Pollicis Longus (C7, C8)', 'Pronator Quadratus (C7, C8)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Thenar Cutaneous Branch',
        muscles: [],
        nerves: [],
        sensory: [],
        cutaneous: ['Palmar Aspect of Thumb']
    },
    {
        title: 'Median Nerve 6',
        muscles: ['Opponens Pollicis (C8, T1)', 'Abductor Pollicis Brevis (C8, T1)', '1/2 Flexor Pollicis Brevis (Superficial Head) (C8, T1)', 'Lumbricals I & II (C8, T1)'],
        nerves: ['Recurrent Motor Branch (C8, T1)', 'Digital Branches (C6, C7, C8)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Recurrent Motor Branch',
        muscles: ['Abductor Pollicis Brevis (C8, T1)', '1/2 Flexor Pollicis Brevis (Superficial Head) (C8, T1)', 'Opponens Pollicis (C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Digital Branches 2',
        muscles: [],
        nerves: [],
        sensory: [],
        cutaneous: ['Palmar Aspect of Second Digit', 'Palmar Aspect of Third Digit', 'Palmar Aspect of Lateral 1/2 of Fourth Digit']
    },

    //--------Brachial Plexus--------//

    {
        title: 'C5 Cervical Nerve 1',
        muscles: ['Rhomboids (C4, C5)', 'Serratus Anterior (C5, C6, C7)', 'Supraspinatus (C5, C6)', 'Infraspinatus (C5, C6)', 'Subclavius (C5, C6)', 'Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Long Thoracic Nerve (C5, C6, C7)', 'Dorsoscapular Nerve (C4, C5)', 'Suprascapular Nerve (C5, C6)', 'Nerve To Subclavius (C5, C6)', 'Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'C5 Cervical Nerve 2',
        muscles: ['Rhomboids (C4, C5)', 'Supraspinatus (C5, C6)', 'Infraspinatus (C5, C6)', 'Subclavius (C5, C6)', 'Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Dorsoscapular Nerve (C4, C5)', 'Suprascapular Nerve (C5, C6)', 'Nerve To Subclavius (C5, C6)', 'Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'C5 Cervical Nerve 3',
        muscles: ['Supraspinatus (C5, C6)', 'Infraspinatus (C5, C6)', 'Subclavius (C5, C6)', 'Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Suprascapular Nerve (C5, C6)', 'Nerve To Subclavius (C5, C6)', 'Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'C6 Cervical Nerve 1',
        muscles: ['Serratus Anterior (C5, C6, C7)', 'Supraspinatus (C5, C6)', 'Infraspinatus (C5, C6)', 'Subclavius (C5, C6)', 'Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Long Thoracic Nerve (C5, C6, C7)', 'Suprascapular Nerve (C5, C6)', 'Nerve To Subclavius (C5, C6)', 'Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'C6 Cervical Nerve 2',
        muscles: ['Supraspinatus (C5, C6)', 'Infraspinatus (C5, C6)', 'Subclavius (C5, C6)', 'Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Suprascapular Nerve (C5, C6)', 'Nerve To Subclavius (C5, C6)', 'Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'C7 Cervical Nerve 1',
        muscles: ['Serratus Anterior (C5, C6, C7)', 'Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Long Thoracic Nerve (C5, C6, C7)', 'Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'C7 Cervical Nerve 2',
        muscles: ['Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'C8 Cervical Nerve',
        muscles: ['Pectoralis Minor (C8, T1)', 'Sternocostal Part of Pectoralis Major (C7, C8, T1)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Medial Pectoral Nerve (C7, C8, T1)', 'Medial Brachial Cutaneous Nerve (C8, T1)', 'Medial Antebrachial Cutaneous Nerve (C8, T1)', 'Median Nerve (C6, C7, C8, T1)', 'Ulnar Nerve (C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'T1 Thoracic Nerve 1',
        muscles: ['Pectoralis Minor (C8, T1)', 'Sternocostal Part of Pectoralis Major (C7, C8, T1)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Medial Pectoral Nerve (C7, C8, T1)', 'Medial Brachial Cutaneous Nerve (C8, T1)', 'Medial Antebrachial Cutaneous Nerve (C8, T1)', 'Median Nerve (C6, C7, C8, T1)', 'Ulnar Nerve (C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Dorsoscapular Nerve',
        muscles: ['Rhomboids (C4, C5)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Long Thoracic Nerve',
        muscles: ['Serratus Anterior (C5, C6, C7)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Superior Trunk 1',
        muscles: ['Supraspinatus (C5, C6)', 'Infraspinatus (C5, C6)', 'Subclavius (C5, C6)', 'Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Suprascapular Nerve (C5, C6)', 'Nerve To Subclavius (C5, C6)', 'Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Suprascapular Nerve 1',
        muscles: ['Supraspinatus (C5, C6)', 'Infraspinatus (C5, C6)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Suprascapular Nerve 2',
        muscles: ['Supraspinatus (C5, C6)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Suprascapular Nerve 3',
        muscles: [],
        nerves: [],
        sensory: ['Acromioclavicular Joint', 'Glenohumeral Joint'],
        cutaneous: []
    },
    {
        title: 'Suprascapular Nerve 4',
        muscles: ['Infraspinatus (C5, C6)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Superior Trunk 2',
        muscles: ['Subclavius (C5, C6)', 'Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Nerve To Subclavius (C5, C6)', 'Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Nerve To Subclavius',
        muscles: ['Subclavius (C5, C6)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Superior Trunk 3',
        muscles: ['Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Anterior Division 1',
        muscles: ['Clavicular Part of Pectoralis Major (C4, C5, C6)', ],
        nerves: ['Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Lateral Cord 1',
        muscles: ['Clavicular Part of Pectoralis Major (C4, C5, C6)', ],
        nerves: ['Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Lateral Pectoral Nerve',
        muscles: ['Clavicular Part of Pectoralis Major (C4, C5, C6)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Lateral Cord 2',
        muscles: [],
        nerves: ['Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Musculocutaneous Branch',
        muscles: [],
        nerves: ['Lateral Cutaneous Nerve'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Middle Trunk 1',
        muscles: ['Clavicular Part of Pectoralis Major (C4, C5, C6)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Lateral Pectoral Nerve (C4, C5, C6)', 'Musculocutaneous Nerve (C5, C6)', 'Median Nerve (C6, C7, C8, T1)', 'Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Posterior Division',
        muscles: ['Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Posterior Cord 1',
        muscles: ['Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Upper Subscapular Nerve (C5, C6)', 'Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Upper Subscapular Nerve',
        muscles: ['Subscapularis (C5, C6)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Posterior Cord 2',
        muscles: ['Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Thoracodorsal Nerve (C7, C8, T1)', 'Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Thoracodorsal Nerve',
        muscles: ['Latissimus Dorsi (C7, C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Posterior Cord 3',
        muscles: ['Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Lower Subscapular Nerve (C5, C6)', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Lower Subscapular Nerve',
        muscles: ['Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Posterior Cord 4',
        muscles: [],
        nerves: ['Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Inferior Trunk 1',
        muscles: ['Pectoralis Minor (C8, T1)', 'Sternocostal Part of Pectoralis Major (C7, C8, T1)', 'Latissimus Dorsi (C7, C8, T1)', 'Subscapularis (C5, C6)', 'Teres Major (C5, C6)'],
        nerves: ['Medial Pectoral Nerve (C7, C8, T1)', 'Medial Brachial Cutaneous Nerve (C8, T1)', 'Medial Antebrachial Cutaneous Nerve (C8, T1)', 'Median Nerve (C6, C7, C8, T1)', 'Ulnar Nerve (C7, C8, T1)', 'Upper Subscapular Nerve', 'Thoracodorsal Nerve', 'Lower Subscapular Nerve', 'Radial Nerve (C4, C5, C6, C7, C8)', 'Axillary Nerve (C5, C6)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Anterior Division 2',
        muscles: ['Pectoralis Minor (C8, T1)', 'Sternocostal Part of Pectoralis Major (C7, C8, T1)', ],
        nerves: ['Medial Pectoral Nerve (C7, C8, T1)', 'Medial Brachial Cutaneous Nerve (C8, T1)', 'Medial Antebrachial Cutaneous Nerve (C8, T1)', 'Median Nerve (C6, C7, C8, T1)', 'Ulnar Nerve (C7, C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Medial Cord 1',
        muscles: ['Pectoralis Minor (C8, T1)', 'Sternocostal Part of Pectoralis Major (C7, C8, T1)', ],
        nerves: ['Medial Pectoral Nerve (C7, C8, T1)', 'Medial Brachial Cutaneous Nerve (C8, T1)', 'Medial Antebrachial Cutaneous Nerve (C8, T1)', 'Median Nerve (C6, C7, C8, T1)', 'Ulnar Nerve (C7, C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Medial Pectoral Nerve',
        muscles: ['Pectoralis Minor (C8, T1)', 'Sternocostal Part of Pectoralis Major (C7, C8, T1)'],
        nerves: [],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Medial Cord 2',
        muscles: [],
        nerves: ['Medial Brachial Cutaneous Nerve (C8, T1)', 'Medial Antebrachial Cutaneous Nerve (C8, T1)', 'Median Nerve (C6, C7, C8, T1)', 'Ulnar Nerve (C7, C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Medial Brachial Cutaneous Nerve',
        muscles: [],
        nerves: [],
        sensory: [],
        cutaneous: ['Medial Arm']
    },
    {
        title: 'Medial Cord 3',
        muscles: [],
        nerves: ['Medial Antebrachial Cutaneous Nerve (C8, T1)', 'Median Nerve (C6, C7, C8, T1)', 'Ulnar Nerve (C7, C8, T1)'],
        sensory: [],
        cutaneous: []
    },
    {
        title: 'Medial Antebrachial Cutaneous Nerve',
        muscles: [],
        nerves: [],
        sensory: [],
        cutaneous: ['Medial Forearm']
    },
    {
        title: 'Medial Cord 4',
        muscles: [],
        nerves: ['Median Nerve (C6, C7, C8, T1)', 'Ulnar Nerve (C7, C8, T1)'],
        sensory: [],
        cutaneous: []
    },
];

export default nerveData;


// WEBPACK FOOTER //
// ./src/reducers/nerve.js